import gql from "graphql-tag";

export const getTransactions = gql`
  query getTransactions(
    $utilisateurId: Int!
    $comptes: [String]!
    $from: Int
    $to: Int
  ) {
    getTransactions(
      utilisateurId: $utilisateurId
      comptes: $comptes
      from: $from
      to: $to
    ) {
      id
      compte
      cleanDescription
      bankDescription
      montant
      date
      currencyCode
      isDeleted
      tva
      category
      isFuture
      fournisseur
      frequence
      frequenceId
      produitId
      produitName
      isProfit
      showClientSide
      splitted
      parent
    }
  }
`;

export const getFrequences = gql`
  query getFrequences($utilisateurId: Int!) {
    getFrequences(utilisateurId: $utilisateurId) {
      fournisseur
      date
      montant
      isProfit
      frequenceId
      produitId
      produitName
      categorieId
      categorieName
      isActive
    }
  }
`;
export const getPrevisionnel = gql`
  query getPrevisionnel($utilisateurId: Int!) {
    getPrevisionnel(utilisateurId: $utilisateurId) {
      name
      produitId
      produit
      categorie
      categorieId
      isProfit
      montantRealise
      montantPrevisionnel
      montantEcart
      week
      date
    }
  }
`;

export const getFournisseurs = gql`
  query getFournisseurs($utilisateurId: Int!, $entreprise: Int!) {
    getFournisseurs(utilisateurId: $utilisateurId, entreprise: $entreprise) {
      id
      name
    }
  }
`;
